/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEmployeeRequest } from '../../models/create-employee-request';
import { Employee } from '../../models/employee';

export interface CreateEmployee$Params {
  organizationId: string;
  
    /**
     * Employee to be created.
     */
    body: CreateEmployeeRequest
}

export function createEmployee(http: HttpClient, rootUrl: string, params: CreateEmployee$Params, context?: HttpContext): Observable<StrictHttpResponse<Employee>> {
  const rb = new RequestBuilder(rootUrl, createEmployee.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Employee>;
    })
  );
}

createEmployee.PATH = '/v1/organizations/{organizationId}/configuration/integration/employees';
